// extracted by mini-css-extract-plugin
export default {"modeltype":"style_modeltype__-pYLl","modelTypeIcon":"style_modelTypeIcon__HtdOV","modelTypeText":"style_modelTypeText__EIaiQ"};